document.addEventListener('DOMContentLoaded', function () {
  const heroSlider = new Swiper('.hero-slider', {
    loop: true,

    effect: 'fade',
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.hero-nav-next',
      prevEl: '.hero-nav-prev',
    },
  });

  console.log('Hero Slider: Zainicjowano');

});